import { StyledAntResult } from './CustomAntResult.styled';
import { ResultProps } from 'antd';

export const CustomAntResult = (props: ResultProps) => (
  <StyledAntResult {...props} />
);
